import './CreateSesi.css';
import React, {useState, useRef} from 'react';
import DatePicker from 'react-date-picker';
import TimePicker from 'react-time-picker';
import axios from 'axios';
import CopyLink from './CopyLink';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications'
import CreateSessionImage from '../../assets/create-session.png'
import Header from '../common/Header'
import { useNavigate } from "react-router-dom";

const CreateSesi =  () => {
    const navigate = useNavigate();
    const todayDate = new Date();
    const initialState = {
        mataKuliah: "",
        topikDiskusi:"",
        pemicuDiskusi:"",
        ketentuanDiskusi:"",
        instruksiFasilitator:"",
        jumlahRuangDiskusi:0,
    }
    const [{mataKuliah, topikDiskusi,pemicuDiskusi, ketentuanDiskusi, instruksiFasilitator,jumlahRuangDiskusi}, setState] = useState(initialState)
    const [tanggalDiskusi, setTanggalDiskusi] = useState(new Date());
    const [waktuMulai, setWaktuMulai] = useState('00:00');
    const [waktuAkhir, setWaktuAkhir] = useState('00:00');
    const [linkLobbyHost, setlinkLobbyHost] = useState('');
    const [sessionData, setSessionData] = useState();
    const [tanggalSesiTerbuat,setTanggalSesiTerbuat] = useState(null)
    const [file, setFile] = useState(null);
    const fileRef = useRef()
    const [linkLobbyPartisipan, setlinkLobbyPartisipan] = useState('');
    const [sessionCreated, setSessionCreated] = useState(false)
    
    const handleFileChange = (event) => {
		setFile(event.target.files[0])
	}

    const onChange = e =>{
        const {name,value} = e.target;
        setState((prevState) => ({...prevState, [name]:value}))
    }
    const clearState = () =>{
        setState({...initialState})
        setWaktuMulai("")
        setWaktuAkhir("")
        setTanggalDiskusi(todayDate)
    }
    const handleDeleteFile = (ref) => {
        setFile(null)
		ref.current.value = null;

    }
    const handleSubmit = (e) => {
        e.preventDefault()

        // Menggabungkan tanggal dan waktu mulai dan akhir, kemudian diubah menjadi string
        const tanggal = (tanggalDiskusi.getMonth() +1) + '/' + tanggalDiskusi.getDate() + '/'+   tanggalDiskusi.getFullYear()
        const waktuMulaiData = tanggal + ' ' + waktuMulai
        const waktuAkhirData = tanggal + ' ' + waktuAkhir  
        
        // Mengecek apakah waktu mulai dan waktu akhir sudah bersesuaian
        const waktuMulaiCheck = new Date(waktuMulaiData)
        const waktuAkhirCheck = new Date(waktuAkhirData)
        if(waktuAkhirCheck.getTime() - new Date().getTime() < 0){
            NotificationManager.error('Schedule end time has passed', 'Error');
            return
        }
        else if(waktuMulaiCheck-waktuAkhirCheck > 0){
            NotificationManager.error('Schedule start time may not later than Schedule End time', 'Error');
            return
        }
        else if(waktuMulaiCheck-waktuAkhirCheck === 0){
            NotificationManager.error('Schedule start time may not set the same with Schedule End time', 'Error');
            return
        }

        let formData = new FormData();
        formData.append('mata_kuliah', mataKuliah);
        formData.append('topik_diskusi',topikDiskusi);
        formData.append('pemicu_diskusi',pemicuDiskusi);
        if(ketentuanDiskusi !== ''){
            formData.append('ketentuan_diskusi',ketentuanDiskusi);
        }
        if(instruksiFasilitator !== ''){
            formData.append('instruksi_fasilitator',instruksiFasilitator);
        }
        formData.append('waktu_mulai',waktuMulaiData);
        formData.append('waktu_akhir',waktuAkhirData);
        formData.append('jumlah_ruang_diskusi',jumlahRuangDiskusi);
        if(file !== ''){
            formData.append('file_materi_diskusi',file)
        }
        const config = {     
            headers: { 'Content-Type': 'multipart/form-data' }
        }    
        axios.post(`https://backend-ta-wiyata.herokuapp.com/create-session/`, formData, config)
            .then(response => {
                const response_data = response.data
                setSessionData(response_data.data)
                console.log(response_data.data)
                setlinkLobbyHost(response_data.data.link_lobby_room_host)
                setlinkLobbyPartisipan(response_data.data.link_lobby_room_partisipan)
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                var date = new Date(response_data.data['waktu_mulai'].split(" ")[0]);
                date = date.toLocaleDateString('en-GB', options)
                setTanggalSesiTerbuat(date)
                NotificationManager.success('Session is made successfully', 'Success');
                setSessionCreated(true)
                clearState()
            })
            .catch(error => {
                console.log(error);
        });
	}   
    const handleToLandingPage = () => {
		navigate("/", {});
	}
    return (
        <div>
            <Header />
            <div class="landing-page">
                { !sessionCreated ? 
                <div class="landing-page-inner">
                    <div className="landing-page-back">
                        <div className="report__back" onClick={handleToLandingPage}>
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26.25 13.75H8.5375L13.0125 9.2625L11.25 7.5L3.75 15L11.25 22.5L13.0125 20.7375L8.5375 16.25H26.25V13.75Z" fill="#165A7C"/>
                            </svg>
                            <div className="report__back--text">Back</div>
                        </div>
                    </div>
                    <div class="landing-page-image">
                        <img src={CreateSessionImage} alt="" className='img-lp-item' />
                    </div>
                    <form class="landing-page-form" onSubmit={handleSubmit}>
                        <h1 class="landing-page__title">Build your own discussion room</h1>
                        <div class="form-wrapper">
                            <div class="form-field">
                                <div class="form-label">Course<span class="text--required"> *</span></div>
                                <input
                                    class="form-input"
                                    type="text" 
                                    name="mataKuliah" 
                                    placeholder="Input the name of course"
                                    value={mataKuliah}
                                    onChange={onChange}
                                    required
                                />
                            </div>
                            <div class="form-field">
                                <div class="form-label">Topic of discussion<span class="text--required"> *</span></div>
                                <input
                                    class="form-input"
                                    type="text" 
                                    name="topikDiskusi" 
                                    placeholder="Input the name of topic"
                                    value={topikDiskusi}
                                    onChange={onChange}
                                    required
                                />
                            </div>
                            <div class="form-field">
                                <div class="form-label">Discussion Question<span class="text--required"> *</span></div>
                                <textarea 
                                    class="form-input"
                                    type="text" 
                                    name="pemicuDiskusi" 
                                    placeholder="Input discussion question for students"
                                    value={pemicuDiskusi}
                                    onChange={onChange}
                                    required
                                    >
                                </textarea>
                            </div>
                            <div class="form-field">
                                <div class="form-label">Discussion terms<span class="text--required"> *</span></div>
                                <textarea 
                                    class="form-input"
                                    type="text" 
                                    name="ketentuanDiskusi" 
                                    placeholder="Input discussion instructions for students"
                                    value={ketentuanDiskusi}
                                    onChange={onChange}
                                    required
                                    >
                                </textarea>
                            </div>
                            <div class="form-field">
                                <div class="form-label">Instructions for facilitators</div>
                                <textarea 
                                    class="form-input"
                                    type="text" 
                                    name="instruksiFasilitator" 
                                    placeholder="Input instructions for  facilitators"
                                    value={instruksiFasilitator}
                                    onChange={onChange}
                                    >
                                </textarea>
                            </div>
                            <div class="form-datetime">
                                <div class="form-label">Schedule date<span class="text--required"> *</span></div>
                                <DatePicker 
                                    onChange={setTanggalDiskusi} 
                                    value={tanggalDiskusi}
                                    format={"y-MM-dd"}
                                    minDate={todayDate}
                                    required />
                            </div>
                            <div class="form-datetime" id="form__waktu-mulai">
                                <div class="form-label">Schedule start Time<span class="text--required"> *</span></div>
                                <TimePicker 
                                    onChange={setWaktuMulai} 
                                    value={waktuMulai}
                                    clockIcon={null}
                                    disableClock = {true}
                                    required/>
                            </div>
                            <div class="form-datetime">
                                <div class="form-label">Schedule end Time<span class="text--required"> *</span></div>
                                <TimePicker 
                                    onChange={setWaktuAkhir} 
                                    value={waktuAkhir}
                                    clockIcon={null}
                                    disableClock = {true}
                                    required/>
                            </div>
                            <div class="form-field">
                                <div class="form-label">Number of rooms<span class="text--required"> *</span></div>
                                <input
                                    class="form-input"
                                    type="number" 
                                    min={1}
                                    name="jumlahRuangDiskusi" 
                                    value={jumlahRuangDiskusi}
                                    onChange={onChange}
                                    required
                                />
                            </div>
                            <div class="form-file">
                                <div class="form-label">Additional Resource</div>
                                <div class="form-file__input">
                                    <input
                                        class="form-input"
                                        type="file" 
                                        name="file" 
                                        ref={fileRef}
                                        onChange={handleFileChange}
                                    />
                                {file!==null? <button  onClick={() =>handleDeleteFile(fileRef)}>Delete File</button>  : null}  
                                </div> 
                            </div>
                        </div>
                        <button class="wiyata-btn">Create</button>
                    </form>
                </div>
                : 
                <div class="landing-page__share-link">
                    <h2>{sessionData.mata_kuliah}</h2>
                    <div class="landing-page__share-link-inner">
                        <h4>{sessionData.topik_diskusi}</h4>
                        <p>{tanggalSesiTerbuat}</p>
                        <p>Start: {sessionData.waktu_mulai.split(" ")[1]} - End: {sessionData.waktu_akhir.split(" ")[1]}</p>
                        <p class="landing-page__excerpt">Please Copy Link Below to Join Session:</p>
                        <CopyLink 
                        linkHost={linkLobbyHost}
                        linkParticipant={linkLobbyPartisipan} 
                        role={'HOST'} />
                    </div>
                </div>
                }
                <NotificationContainer/>
            </div>
        </div>
        
    )
}
export default CreateSesi;